import queryString from 'query-string';

import {
  convertArrayToObject,
  paramBuilder,
  routeToScope,
  routeToSpecificScope,
  routeToViewPracticeGamePageScope
} from '../../helpers';
import * as eventsType from '../types';
import { SERVER } from '../../config/server.config';
import { addLoadingFlag, subLoadingFlag } from './loading';
import { requestData } from '../../config/services/datasets';
import store from '../index';
import { FILTER_KEYS, LEAGUE, SCOPE } from '../../config/constants';

export const replaceEntities = entities => {
  return {
    type: eventsType.UPDATE_ENTITIES,
    entities: entities
  };
};

export const getEntities = (homeTeam) => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const user = getState().user;
    const { byTeam } = getState().entities;
    let league = user.league;
    if (league === '*') {
      league = 'ncaa-fbs,ncaa-mlax,nfl';
    }
    const specificScope = routeToSpecificScope(path);
    let isHomeTeamStrg;
    if(typeof(homeTeam)=== "string"){
      isHomeTeamStrg = true;
    }else{
      isHomeTeamStrg = false;
    }
    const teamId = homeTeam ? isHomeTeamStrg ? homeTeam : homeTeam.value.siteId : (getState().filters[specificScope] && getState().filters[specificScope][FILTER_KEYS.VENUE]) ? 
    getState().filters[specificScope][FILTER_KEYS.VENUE].value.teamId : getState().user.teamId;
    const siteId = (getState().filters[specificScope] && getState().filters[specificScope][FILTER_KEYS.VENUE]) ? 
    getState().filters[specificScope][FILTER_KEYS.VENUE].value.siteId : getState().user.teamId;
    dispatch(addLoadingFlag(specificScope));
    let params = {
      league: (getState().filters[specificScope] && getState().filters[specificScope][LEAGUE.filterKey]) ? getState().filters[specificScope][LEAGUE.filterKey] : { value: { value: league } },
      type: (getState().filters[specificScope] && getState().filters[specificScope][LEAGUE.filterKey]) ? getState().filters[specificScope][LEAGUE.filterKey].value.type : 'practice',
      teamids: teamId
    };
    if (!byTeam) {
      params = { ...params, includeTeams: 'false', teamids: siteId };
    }
    const results = await requestData(SERVER.ENTITIES_BY_TEAM(byTeam) + paramBuilder(params)); //league=${league}&type=practice&teamids=${teamId}
    let entities = {};
    if (results) {
      //sometimes entities arrive without _id
      //entities = convertArrayToObject(results, '_id'); 
      entities = convertArrayToObject(results, 'id');
    }
    if (entities && results) {
      dispatch(replaceEntities(entities));
    }
    dispatch(subLoadingFlag(specificScope));
  };
};
export const getEntitiesDataOps = (practice) => {
  //league=nfl&type=practice&teamids=2510&datasetId=20191121251000&editEntities=true&end_time=1574378381459&siteId=2510&start_time=1574370610000&retrack=yes
  const params = {
    league: practice.league,
    type: practice.type,
    teamIds: practice.home_team_id,
    datasetId: practice.dataset_id,
    editEntities: true,
    end_time: practice.end_time,
    start_time: practice.start_time,
    siteId: practice.site_id,
    retrack: 'yes'
  };

  return async dispatch => {
    const scope = 'DATAOPS_ENTITIES_TEST';
    dispatch(addLoadingFlag(scope));
    const results = await requestData(SERVER.ENTITIES_DATAOPS(practice.dataset_id) + queryString.stringify(params, { arrayFormat: 'comma' }));
    let entities = {};
    if (results) {
      entities = convertArrayToObject(results, '_id');
    }
    if (entities && results) {
      dispatch(replaceEntities(entities));
    }
    dispatch(subLoadingFlag(scope));
  };
};

export const getLiveEntities = (id) => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToViewPracticeGamePageScope(path);
    dispatch(addLoadingFlag(scope));
    const results = await requestData(SERVER.LIVE_PRACTICE_ENTITIES(id));
    if (results) {
      dispatch(replaceEntities(results));
    }
    dispatch(subLoadingFlag(scope));
  };
};

export const createEntity = (entity, extraData) => {
  const path = store.getState().router.location.pathname;
  const scope = routeToSpecificScope(path);
  const { byTeam } = store.getState().entities;
  const siteId = (store.getState().filters[scope] && store.getState().filters[scope][FILTER_KEYS.VENUE]) ? 
  store.getState().filters[scope][FILTER_KEYS.VENUE].value.siteId : store.getState().user.teamId;
  const teamId = store.getState().filters[scope] && store.getState().filters[scope].venue && store.getState().filters[scope].venue.value ?
    store.getState().filters[scope].venue.value.teamId : store.getState().user.teamId;
  const league = store.getState().filters[scope] && store.getState().filters[scope].venue && store.getState().filters[scope].venue.value ?
    store.getState().filters[scope].venue.value.league : store.getState().user.league;
  const body = {
    entities: [{
      model: entity.model,
      type: entity.type,
      group: entity.group,
      name: entity.name,
      namespaced_id: entity.namespaced_id,
      tags: entity.tags,
      extra_data: extraData
    }]
  };
  const request = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(body)
  };

  return async (dispatch, getState) => {
    const params = {
      league: (getState().filters[scope] && getState().filters[scope][LEAGUE.filterKey]) ? getState().filters[scope][LEAGUE.filterKey] : { value: { value: league } },
      type: (getState().filters[scope] && getState().filters[scope][LEAGUE.filterKey]) ? getState().filters[scope][LEAGUE.filterKey].value.type : 'practice',
      teamids: byTeam ? teamId : siteId
    };
    dispatch(addLoadingFlag(scope));
    const response = await fetch(SERVER.CREATE_ENTITY() + paramBuilder(params), request); //league=${league}&type=practice&teamids=${teamId}
    if (!response.ok && response.status !== 500) {
      throw Error(response.statusText);
    }
    dispatch(subLoadingFlag(scope));
    //let responseJson = await response.json();
    //if (responseJson) {
    dispatch(getEntities());
    //}
  };
};
export const createEntityDataOps = (entity, extraData, practice) => {
  const teamId = practice.home_team_id;
  const params = {
    league: practice.league,
    type: practice.type,
    teamIds: teamId,
    retrack: 'yes'
  };
  const body = {
    entities: [{
      model: entity.model,
      type: entity.type,
      group: entity.group,
      name: entity.name,
      namespaced_id: entity.namespaced_id,
      tags: entity.tags,
      extra_data: extraData
    }]
  };
  const request = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(body)
  };

  return async dispatch => {
    const response = await fetch(SERVER.CREATE_ENTITY_DATAOPS(practice.dataset_id) + queryString.stringify(params, { arrayFormat: 'comma' }), request);
    if (!response.ok) {
      throw Error(response.statusText);
    }
    const responseJson = await response.json();
    if (responseJson) {
      dispatch(getEntitiesDataOps(practice));
    }
  };
};
//league=nfl&type=practice&teamids=2510&retrack=yes
export const editEntity = (entity, extraData, entityLeague) => {
  const path = store.getState().router.location.pathname;
  const specificScope = routeToSpecificScope(path);
  const scope = routeToScope(path);
  const { byTeam } = store.getState().entities;
  const siteId = (store.getState().filters[specificScope] && store.getState().filters[specificScope][FILTER_KEYS.VENUE]) ?
      store.getState().filters[specificScope][FILTER_KEYS.VENUE].value.siteId :
      store.getState().user.teamId;
  const teamId = scope === SCOPE.DATAOPS.ENTITIES ? entity.extra_data.teamId : store.getState().filters[scope].venue ? store.getState().filters[scope].venue.value.teamId :
    store.getState().user.teamId;
  const league = entityLeague? entityLeague : scope === SCOPE.DATAOPS.ENTITIES ?
    store.getState().user.league : store.getState().filters[scope].venue ?
      store.getState().filters[scope].venue.value.league : store.getState().user.league === '*' ?
        'nfl,ncaa-mlax,ncaa-fbs' : store.getState().user.league;
  const body = {
    _id: entity._id,
    model: entity.model,
    type: entity.type,
    tags: entity.tags,
    extra_data: extraData,
    group: entity.group,
    name: entity.name,
    namespaced_id: entity.namespaced_id,
    namespace: entity.type, // need to change this
    id: entity.id,
    source: 'gdop'
  };
  const request = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(body)
  };

  return async (dispatch, getState) => {
    dispatch(addLoadingFlag(specificScope));
    const params = {
      league: { value: { value: league } },
      type: (getState().filters[specificScope] && getState().filters[specificScope][LEAGUE.filterKey]) ? getState().filters[specificScope][LEAGUE.filterKey].value.type : 'practice',
      teamids: byTeam ? teamId : siteId
    };
    const response = await fetch(SERVER.EDIT_ENTITY(entity._id) + paramBuilder(params), request); //league=${league}&type=practice&teamids=${teamId}
    if (!response.ok && response.status !== 500) {
      throw Error(response.statusText);
    }
    dispatch(subLoadingFlag(specificScope));

    // let responseJson = await response.json();
    // if (responseJson) {
    dispatch(getEntities());
    // }
  };
};

export const editEntityDataOps = (entity, extraData, practice) => {
  const teamId = practice.home_team_id;
  const league = practice.league;
  const params = {
    league: practice.league,
    type: practice.type,
    teamIds: teamId,
    retrack: 'yes'
  };
  const body = {
    _id: entity._id,
    model: entity.model,
    type: entity.type,
    tags: entity.tags,
    extra_data: extraData,
    group: entity.group,
    name: entity.name,
    namespaced_id: entity.namespaced_id,
    namespace: entity.type, // need to change this
    id: entity.id,
    source: 'gdop'
  };
  const request = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(body)
  };
  return async dispatch => {
    if(entity._id){
      const response = await fetch(SERVER.EDIT_ENTITY_DATAOPS(entity._id, practice.dataset_id, league) + queryString.stringify(params, { arrayFormat: 'comma' }), request);
      if (!response.ok) {
        throw Error(response.statusText);
      }
      const responseJson = await response.json();
      if (responseJson) {
        dispatch(getEntitiesDataOps(practice));
      }
    }
  };
};

export const deleteEntity = entity => {
  const path = store.getState().router.location.pathname;
  const scope = routeToSpecificScope(path);
  const { byTeam } = store.getState().entities;
  const siteId = (store.getState().filters[scope] && store.getState().filters[scope][FILTER_KEYS.VENUE]) ?
    store.getState().filters[scope][FILTER_KEYS.VENUE].value.siteId : store.getState().user.teamId;
  const teamId = store.getState().filters[scope] ? store.getState().filters[scope].venue.value.teamId : store.getState().user.teamId;
  const league = store.getState().filters[scope] ? store.getState().filters[scope].venue.value.league : store.getState().user.league;
  const request = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  };
  return async (dispatch, getState) => {
    const params = {
      league: { value: { value: league } },
      type: (getState().filters[scope] && getState().filters[scope][LEAGUE.filterKey]) ? getState().filters[scope][LEAGUE.filterKey].value.type : 'practice',
      teamids: byTeam ? teamId : siteId
    };
    dispatch(addLoadingFlag(scope));
    const response = await fetch(SERVER.DELETE_ENTITY(entity._id) + paramBuilder(params), request); //league=${league}&type=practice&teamids=${teamId}
    if (!response.ok) {
      throw new Error(response.statusText);
    } 
    const data = await response.json();
   if(data){
    dispatch(subLoadingFlag(scope));
    dispatch(getEntities());
   }
    
    
  };
};

export const deleteAllEntitiesTags =(teamId) =>{
  const path = store.getState().router.location.pathname;
  const specificScope = routeToSpecificScope(path);
  return async (dispatch) => {
    dispatch(addLoadingFlag(specificScope));
    const results = await requestData(SERVER.DELETE_ALL_ENTITIES_TAGS(teamId));
    if (results) {
      dispatch(getEntities());
    }
      dispatch(subLoadingFlag(specificScope));
    };
};

//type=practice&teamids=2510&datasetId=20191011251000&retrack=yes
export const deleteEntityDataOps = (entity, practice) => {
  const teamId = practice.home_team_id;
  const league = practice.league;
  const params = {
    type: practice.type,
    teamIds: teamId,
    datasetId: practice.dataset_id,
    retrack: 'yes'
  };
  const request = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  };
  return async dispatch => {
    fetch(SERVER.DELETE_ENTITY(entity._id, teamId, league) + queryString.stringify(params, { arrayFormat: 'comma' }), request).then(
      dispatch(getEntities())
    );
  };
};

export const handleOnByTeamToggle = toggle => {
  return dispatch => {
    dispatch({ type: eventsType.TOGGLE_BY_TEAM_CHECKBOX, toggle });
  };
};

export const cleanEntitiesState = () => {
  return dispatch => {
    dispatch({ type: eventsType.CLEAN_ENTITIES_STATE });
  };
};
